var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "checkout-order h-100" },
    [
      _vm.stage == _vm.CHECKOUT.SUGGESTIONS
        ? _c("CheckoutSuggestions", {
            attrs: { order: _vm.order, modal: _vm.modal },
            on: { go: _vm.go },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.stage == _vm.CHECKOUT.SALON
        ? _c("CheckoutSalon", {
            attrs: { order: _vm.order, modal: _vm.modal },
            on: { go: _vm.go },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.stage == _vm.CHECKOUT.HOME
        ? _c("CheckoutHome", {
            staticClass: "checkout-order--component delivery-mode",
            attrs: { order: _vm.order, modal: _vm.modal },
            on: { go: _vm.go },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.stage == _vm.CHECKOUT.DELIVERY_MODE
        ? _c("DeliveryMode", {
            staticClass: "checkout-order--component delivery-mode",
            attrs: { order: _vm.order, modal: _vm.modal },
            on: { go: _vm.go },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.stage == _vm.CHECKOUT.CHOOSE_SHOP
        ? _c("StageChooseShop", {
            staticClass: "checkout-order--component stage-choose-shop",
            attrs: { order: _vm.order, modal: _vm.modal },
            on: { go: _vm.go },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.stage == _vm.CHECKOUT.DELIVERY_ADDRESS
        ? _c("CheckoutAddress", {
            staticClass: "checkout-order--component checkout-address",
            attrs: { order: _vm.order, modal: _vm.modal },
            on: { go: _vm.go },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.stage == _vm.CHECKOUT.EDIT_ADDRESS
        ? _c("EditAddress", {
            staticClass: "checkout-order--component checkout-address",
            attrs: { address: _vm.param, order: _vm.order, modal: _vm.modal },
            on: { go: _vm.go, "set-address": _vm.setAddress },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.stage == _vm.CHECKOUT.DELIVERY_DATE
        ? _c("DeliveryDate", {
            staticClass: "checkout-order--component delivery-date",
            attrs: { order: _vm.order, modal: _vm.modal },
            on: { go: _vm.go },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.stage == _vm.CHECKOUT.PAYMENT
        ? _c("CheckoutPayment", {
            staticClass: "checkout-order--component checkout-payment",
            attrs: { order: _vm.order, modal: _vm.modal },
            on: { go: _vm.go },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.stage == _vm.CHECKOUT.CHOOSE_CONFIRM_METHOD
        ? _c("ChooseConfirmMethod", {
            staticClass: "checkout-order--component choose-confirm-method",
            attrs: { order: _vm.order, modal: _vm.modal },
            on: { go: _vm.go },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.stage == _vm.CHECKOUT.PAY_GREEN
        ? _c("PayGreen", {
            attrs: { order: _vm.order, param: _vm.param, modal: _vm.modal },
            on: { go: _vm.go },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.stage == _vm.CHECKOUT.DSP2
        ? _c("Dsp2", {
            attrs: { order: _vm.order, param: _vm.param, modal: _vm.modal },
            on: { go: _vm.go },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.stage == _vm.CHECKOUT.EDENRED
        ? _c("Edenred", {
            attrs: { order: _vm.order, modal: _vm.modal },
            on: { go: _vm.go },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.stage == _vm.CHECKOUT.SIGNUP_AFTER_CONFIRM
        ? _c("SignupAfterConfirm", {
            staticClass: "checkout-order--component signup-after-confirm",
            attrs: { order: _vm.order, modal: _vm.modal },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }